import { createAsyncThunk } from '@reduxjs/toolkit';
import { brandingService } from '@simwood/nv-react-components';
import { nvFetch } from '../helpers/nvFetch';
import { isWeb } from '../helpers/platform';
import * as platformApi from '../helpers/platformApi';
import {
  ApiPhoneExtension,
  ApiPhoneExtensionWithSip,
} from '../types/PhoneExtension';
import { ApiSipIdentity } from '../types/SipIdentity';
import type { ThunkAPI } from './index';

export const fetchBranding = createAsyncThunk(
  'branding/fetch',
  async (partnerId?: string) => {
    const { brand: res } = await brandingService.fetchBranding(partnerId);

    await platformApi.setRequestReferer(res.website || '');

    brandingService.applyBranding(res, 'communicator', isWeb());

    return res;
  },
);

export const finaliseLogout = createAsyncThunk<void, void, ThunkAPI>(
  'user/finaliseLogout',
  async (_, thunkAPI) => {
    const logoutRedirectUrl =
      thunkAPI.getState().branding.branding?.logoutRedirectUrl;

    if (logoutRedirectUrl) {
      platformApi.hasLoggedOut();

      window.location.href = `${logoutRedirectUrl}?rurl=${window.location.origin}`;
    } else {
      try {
        await nvFetch(`/authenticate/logout`, {
          method: 'POST',
        });
      } catch (err) {
        // allowed to fail
        console.error(err);
      } finally {
        platformApi.hasLoggedOut();
      }
    }
  },
);

export const fetchExtensionDetails = createAsyncThunk<
  ApiPhoneExtensionWithSip,
  string,
  ThunkAPI
>('extension/fetchDetails', async (extensionId, thunkAPI) => {
  const {
    client: { activeCustomer },
  } = thunkAPI.getState();

  if (!extensionId) {
    throw new Error();
  }

  const extensionURI = `/customers/${activeCustomer?.id}/endpoints/${extensionId}`;

  const fetchExtension = async () => {
    const fetchRes = await nvFetch(`${extensionURI}?extended=true`);
    return (await fetchRes.json()) as ApiPhoneExtension;
  };
  const fetchSipIdentity = async () => {
    const fetchRes = await nvFetch(`${extensionURI}/sip`);
    return (await fetchRes.json()) as ApiSipIdentity;
  };

  const promises = [fetchExtension(), fetchSipIdentity()] as const;

  const [extension, sip] = await Promise.all(promises);
  return { ...extension, sip };
});
